// extracted by mini-css-extract-plugin
export default {"title":"styles__title___fmofL","linkTitle":"styles__linkTitle___+UIDH styles__title___fmofL"};